<template>
<div>

    <Layout v-if="cstore.getCruiseBook.ok" :slotInfoLinkRooms="false" :CruiseBook="cstore.getCruiseBook.resolve">
        <template>
        </template>
        <template #after>
            <CabinsGuests />
            <BookCabins :ForFill="true" />
        </template>
    </Layout>

    <div v-if="cstore.getCruiseBook.wait" class="CruisePage__ifloader"><Loader class="CruisePage__loader" /></div>

    <div v-if="cstore.getCruiseBook.reject">! не удалось</div>
</div>
</template>

<script setup>
import {ref, unref, watch, computed, nextTick, onMounted} from 'vue' 
import { useRoute } from 'vue-router/composables'
import Layout from '@/comp/CruiseHead/Layout.vue'
import useCruiseStore from '@/cstore.js'
import useCabinsStore from '@/bookCabins.js'
import useTouristStore from '@/tourist/tourist-store.js'
import Loader from '@/comp/Loader/Loader.vue'
import BookCabins from '@/comp/BookCabins/BookCabins.vue'
import CabinsGuests from '@/comp/FaseBook/CabinsGuests.vue'


const cstore = useCruiseStore()
const tstore = useTouristStore()
const bookCabins = useCabinsStore()
const route = useRoute()

watch( 
    [   
        () => route.query.cruiseIdFull,
    ],
    (   [cruiseIdFull], 
        [old_cruiseIdFull]
    ) => {
        if (!old_cruiseIdFull || cruiseIdFull !== old_cruiseIdFull) {
            if (!cstore.getCruiseBook.is || cruiseIdFull !== cstore.getCruiseBook.params.cruiseIdFull) {
                cstore.loadCruiseBook( { cruiseIdFull } )
            }
        }
    },
    { immediate: true }
)
</script>
